import { ReactElement, useEffect, useState } from 'react';
import styles from './ApplicationForm.module.scss';

/**
 * Wrapper component to conditionally hide/show `children` components
 * @param {Object} props component properties
 * @param {Array} props.dependentValues list of values to watch for changes
 * @param {Function} props.handleCloak handler function to run when `dependentValues` changes
 * @param {ReactElement} props.children the child components to render when appropriate
 * @example `SomeChildComponent` will be rendered only when `test()` returns `true`.  `setShow()` will trigger only when `someWatchedValue1` and `someWatchedValue2` change
 * <InvisibilityCloak
 * 	name='cloak'
 * 	handleCloak={setShow => { setShow(test()); } }}
 * 	dependentValues={[someWatchedValue1, someWatchedValue2]}>
 * 		<SomeChildComponent />
 * </InvisibilityCloak>
 * @returns `children` when appropriate
 */
const InvisibilityCloak = ({ dependentValues, handleCloak, children }) => {
	const [show, setShow] = useState(false);
	useEffect(() => {
		if (dependentValues && handleCloak) {
			handleCloak(setShow);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [...dependentValues]);
	return <div className={styles['full-width']}>{show ? children : null}</div>;
};

export default InvisibilityCloak;
